import { render, staticRenderFns } from "./FileUploadMock.vue?vue&type=template&id=58eb9b0e&scoped=true&"
import script from "./FileUploadMock.vue?vue&type=script&lang=js&"
export * from "./FileUploadMock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb9b0e",
  null
  
)

export default component.exports